package org.gymly.model

/** Resultado de un login unificado (web): personal → admin, socio → portal. */
sealed class LoginSuccess {
    data class Admin(val user: AdminUser) : LoginSuccess()
    data class Portal(val user: PortalUser) : LoginSuccess()
}
